import React from 'react';
import { Table, Card, Tabs } from 'antd';
import styles from './Network.module.scss';

const { TabPane } = Tabs;

const NetworkRouting = ({ routeInfo }) => {
  // 라우팅 정보 파싱
  const parseRouteInfo = (routeInfo) => {
    if (!routeInfo || routeInfo === 'N/A') return null;

    const sections = {
      'Default Routing': [],
      'Network Routing': [],
      'Local Routing': [],
      'Broadcast Routing': [],
      'IPv6 Routing': [],
      'Unreachable Routes': []
    };

    let currentSection = '';
    const lines = routeInfo.split('\n');

    lines.forEach(line => {
      if (line.startsWith('===')) {
        currentSection = line.replace(/===/g, '').trim();
        return;
      }

      if (!line.trim() || line.includes('Network\tGateway') || line.includes('Type\tNetwork')) {
        return;
      }

      const parts = line.split('\t');
      if (parts.length < 3) return;

      const entry = {};
      
      if (currentSection === 'Default Routing' || currentSection === 'Network Routing' || currentSection === 'IPv6 Routing') {
        [entry.network, entry.gateway, entry.interface, entry.flags] = parts;
      } else if (currentSection === 'Local Routing' || currentSection === 'Broadcast Routing') {
        [entry.type, entry.network, entry.interface, entry.flags] = parts;
      } else if (currentSection === 'Unreachable Routes') {
        [entry.type, entry.network, entry.flags] = parts;
      }

      if (sections[currentSection]) {
        sections[currentSection].push({
          ...entry,
          key: Math.random().toString(36).substr(2, 9)
        });
      }
    });

    return sections;
  };

  const parsedData = parseRouteInfo(routeInfo);

  if (!parsedData) {
    return null;
  }

  // 표준 라우팅 컬럼 (Default, Network, IPv6)
  const standardColumns = [
    { title: '네트워크', dataIndex: 'network', key: 'network' },
    { title: '게이트웨이', dataIndex: 'gateway', key: 'gateway' },
    { title: '인터페이스', dataIndex: 'interface', key: 'interface' },
    { title: '플래그', dataIndex: 'flags', key: 'flags' },
  ];

  // 타입 기반 라우팅 컬럼 (Local, Broadcast)
  const typeBasedColumns = [
    { title: '타입', dataIndex: 'type', key: 'type' },
    { title: '네트워크', dataIndex: 'network', key: 'network' },
    { title: '인터페이스', dataIndex: 'interface', key: 'interface' },
    { title: '플래그', dataIndex: 'flags', key: 'flags' },
  ];

  // Unreachable 라우팅 컬럼
  const unreachableColumns = [
    { title: '타입', dataIndex: 'type', key: 'type' },
    { title: '네트워크', dataIndex: 'network', key: 'network' },
    { title: '플래그', dataIndex: 'flags', key: 'flags' },
  ];

  return (
    <Card title="라우팅 테이블" className={styles.networkCard}>
      <Tabs defaultActiveKey="default">
        <TabPane tab="기본 라우팅" key="default">
          <Table 
            dataSource={parsedData['Default Routing']} 
            columns={standardColumns} 
            pagination={false}
            rowKey="key"
          />
        </TabPane>
        <TabPane tab="네트워크 라우팅" key="network">
          <Table 
            dataSource={parsedData['Network Routing']} 
            columns={standardColumns} 
            pagination={false}
            rowKey="key"
          />
        </TabPane>
        <TabPane tab="로컬 라우팅" key="local">
          <Table 
            dataSource={parsedData['Local Routing']} 
            columns={typeBasedColumns} 
            pagination={false}
            rowKey="key"
          />
        </TabPane>
        <TabPane tab="브로드캐스트 라우팅" key="broadcast">
          <Table 
            dataSource={parsedData['Broadcast Routing']} 
            columns={typeBasedColumns} 
            pagination={false}
            rowKey="key"
          />
        </TabPane>
        <TabPane tab="IPv6 라우팅" key="ipv6">
          <Table 
            dataSource={parsedData['IPv6 Routing']} 
            columns={standardColumns} 
            pagination={false}
            rowKey="key"
          />
        </TabPane>
        <TabPane tab="도달 불가능 라우팅" key="unreachable">
          <Table 
            dataSource={parsedData['Unreachable Routes']} 
            columns={unreachableColumns} 
            pagination={false}
            rowKey="key"
          />
        </TabPane>
      </Tabs>
    </Card>
  );
};

export default NetworkRouting;